export default __webpack_public_path__ + "static/media/DNo.38-0.68984441.jpg";